import { useCallback, useState } from 'react'
import { Row, Col, Icon, Message, MultipleSelect, Button } from '@iqueue/ui-kit'
import SettingsPresenter from '../../../api/SettingsPresenter'
import PickTables from '../../picker/PickTables'
import { t } from '../../../hooks/useTranslate'

export default function SettingsChips2({ chips, onChange }) {
  const [draggingChip, setDraggingChip] = useState(null)
  const [placeholderIndex, setPlaceholderIndex] = useState(null)

  const handleDeleteChip = useCallback((indexToDelete) => {
    onChange((prevChips) => prevChips.filter((_, index) => index !== indexToDelete))
  }, [])

  const handleDragStart = useCallback((chip, index) => {
    setDraggingChip(index)
  }, [])

  const handleDragOver = useCallback((e, index) => {
    e.preventDefault()

    const rect = e.target.getBoundingClientRect()
    const offset = e.clientX - rect.left

    if (offset < rect.width / 2) {
      setPlaceholderIndex(index)
    } else {
      setPlaceholderIndex(index + 1)
    }
  }, [])

  const handleDrop = useCallback(() => {
    if (draggingChip !== null && placeholderIndex !== null) {
      const updatedChips = [...chips]

      const [removedChip] = updatedChips.splice(draggingChip, 1)

      const insertIndex = placeholderIndex > draggingChip ? placeholderIndex - 1 : placeholderIndex
      updatedChips.splice(insertIndex, 0, removedChip)

      onChange(updatedChips)
    }

    setDraggingChip(null)
    setPlaceholderIndex(null)
  }, [draggingChip, placeholderIndex, chips])

  return <div className="chips-autocomplete-container">
    <b>{ t('settingsPage.chips.tableOrder') }</b>
    <Row>
      <PickTables
        size={ 12 }
        name={ 'table' }
        placeholder={ t('settingsPage.chips.selectTables') }
        onChange={ (item) => onChange(item) }
        render={ (i) => ({
          id: i,
          title: i,
        }) }
        value={ chips }
      />
    </Row>
    <Row>
      <Col size={ 12 }>
        <div className="chips-list">
          { chips.map((chip, index) => <div
            key={ chip }
            className={ `chip ${ draggingChip === chip ? 'dragging' : '' }` }
            draggable
            onDragStart={ () => handleDragStart(chip, index) }
            onDragOver={ (e) => handleDragOver(e, index) }
            onDrop={ handleDrop }
          >
            { placeholderIndex === index && <div className="drop-placeholder"/> }

            <span className="main-chip">{ t(`settingsPage.tables.${ chip }`) }</span>
            <span
              className="chip-delete"
              onClick={ () => handleDeleteChip(index) }
            >
                  <Icon>delete</Icon>
                </span>
          </div>) }

          { placeholderIndex === chips.length && <div className="drop-placeholder"/> }
        </div>
      </Col>
    </Row>
  </div>
}
